<template>
  <div class="hidden md:flex md:flex-shrink-0 w-full">
    <div class="flex flex-col pl-2 pt-2 w-full">
      <div class="flex items-center px-2">
        <div class="text-xl leading-6">
          <router-link :to="{ name: 'home' }">Sort Work</router-link>
        </div>
      </div>
      <div class="mt-5 px-2 flex-1 w-full">
        <div class="mb-4 relative">
          <NewButton></NewButton>
        </div>
        <div class="mb-4 relative">
          <div class="border-b border-gray-200 text-xs text-gray-600 uppercase mb-1">Prices</div>
          <SidebarNav></SidebarNav>
          <div class="absolute z-10 bottom-0 w-full h-8 border-t border-gray-200 text-gray-500 text-center">- -</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarNav from '@/components/sidebar/SidebarNav'
import NewButton from '@/components/NewButton'

export default {
  name: 'SidebarDesktop',
  components: {
    SidebarNav,
    NewButton
  }
}
</script>
